import { BarChart, Bar, ResponsiveContainer } from "recharts";
import { Users } from "lucide-react";
import { useTranslation } from "@/shared/providers/LanguageProvider";
import { totalFollowersConfig } from "./data";

export function TotalFollowers() {
  const { t } = useTranslation();
  const config = totalFollowersConfig;

  return (
    <div className={`card-shadow rounded-2xl ${config.bg} p-5`}>
      <div className="flex items-center justify-between gap-4">
        <div className="min-w-0">
          <div className="flex items-center gap-2.5">
            <div className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-lg ${config.iconBg}`}>
              <Users size={16} className={config.iconColor} strokeWidth={1.75} />
            </div>
            <p className="text-sm font-medium text-muted-foreground">{t.crm.totalFollowers}</p>
          </div>
          <p className="mt-3 text-2xl font-bold text-foreground">{config.value}</p>
          <p className={`mt-0.5 text-xs font-medium ${config.changeColor}`}>{t.crm.changeFollowers}</p>
        </div>
        <div className="w-[90px] shrink-0">
          <ResponsiveContainer width="100%" height={60}>
            <BarChart data={config.chartData} barCategoryGap="15%">
              <Bar dataKey="v" fill={config.chartColor} radius={[3, 3, 0, 0]} maxBarSize={8} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}
